import isPlainObject from 'lodash/isPlainObject';
import ParamsService from '@/utils/ParamsService';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';

function isMappingSetupFinished(currentMapping, service) {
	if (!currentMapping || !currentMapping.metadata || !currentMapping.metadata.source) {
		return false;
	}
	const {
		metadata: {
			source: { params_map, service: serviceId, field_item },
		},
	} = currentMapping;

	if (!params_map || !serviceId || !field_item) {
		return false;
	}

	const requiredServiceParams = ParamsService.getParamsForMappingByItem(service, field_item).filter((x) => x.required);

	return requiredServiceParams.every((p) => {
		const value = params_map[p.key];
		return !isNullOrUndefinedOrEmpty(value);
	});
}

function isMappingResponseValid(val) {
	// validate params_map exists and is an object, validate that *if* mappings exits, it is an array
	return val && (val.params_map ? isPlainObject(val.params_map) : false) && (val.mappings ? Array.isArray(val.mappings) : true);
}

function isValidMappingResponse(paramsDefinition, responseParamsMap) {
	const isValid = paramsDefinition.reduce((accum, param) => accum && !isNullOrUndefinedOrEmpty(responseParamsMap[param.key]), true);
	return isValid;
}

const DynamicDataService = {
	isMappingSetupFinished,
	isMappingResponseValid,
	isValidMappingResponse,
};

export default DynamicDataService;
